module.exports = "\n<div class=\"btn-group\" data-toggle=\"buttons\">\n  <slot></slot>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-strap/src/checkboxGroup.vue
// module id = 482
// module chunks = 0